import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { subscribeWithSelector } from "zustand/middleware";
import sqliteStorage from "./sqliteStorage";

const DEFAULTS = {
  dineIn: null,
  tableName: null,
  locatedList: [],
  homeDelivery: "N",
  tokenData: null,
  orderDetails: null,
  cancelKOTRemarks: null,
  wastageflag: null,
};

const useRestaurantStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...DEFAULTS,
        _hydrated: false,

        // Actions
        setDineIn: (val) => set({ dineIn: val }),
        setTableName: (table) => set({ tableName: table }),
        setLocatedList: (list) => set({ locatedList: list }),
        setHomeDelivery: (val) => set({ homeDelivery: val }),
        setTokenData: (data) => set({ tokenData: data }),
        setOrderDetails: (details) => set({ orderDetails: details }),
        setCancelKOTRemarks: (remarks) => set({ cancelKOTRemarks: remarks }),
        setWastageflag: (flag) => set({ wastageflag: flag }),

        clearRestaurant: () => set({ ...DEFAULTS }),
      }),
      {
        name: "restaurantStore",
        storage: createJSONStorage(() => sqliteStorage),
        skipHydration: true,
        partialize: (state) => ({
          dineIn: state.dineIn,
          tableName: state.tableName,
          locatedList: state.locatedList,
          homeDelivery: state.homeDelivery,
          tokenData: state.tokenData,
          orderDetails: state.orderDetails,
          cancelKOTRemarks: state.cancelKOTRemarks,
          wastageflag: state.wastageflag,
        }),
        merge: (persisted, current) => ({
          ...current,
          ...DEFAULTS,
          ...(persisted || {}),
          _hydrated: true,
        }),
      }
    )
  )
);

export default useRestaurantStore;
